import {Tunings, WidgetLayout} from '../../../types/tunings';
import {ButtonSizes} from '../../../modules/site-details/customize/button-settings/button.constants';
import {createStore, withProps} from '@ngneat/elf';

export interface TuningsState {
  tunings: Partial<Tunings>;
  updatedTunings: Partial<Tunings>;
  tuningsFetched: boolean;
  isLoading: boolean;
}

export function createInitialTuningsState(): TuningsState {
  return {
    tunings: initDefaultTunings(),
    updatedTunings: initDefaultTunings(),
    tuningsFetched: false,
    isLoading: false,
  };
}

function initEmptyNudge() {
  return JSON.stringify({moveX: 0, moveY: 0, xOrientation: 'left', yOrientation: 'top'});
}

function initDefaultTunings() {
  return {
    accessibility_link_enabled: null,
    accessibility_link_text: null,
    accessibility_url: null,
    site_name: null,
    widget_color: '#0048FF',
    paidAi: false,
    widget_color_gradient: 'off',
    widget_hidden_for_site: null,
    widget_hidden_for_mobile: false,
    widget_sounds: false,
    widget_icon_size: ButtonSizes.small,
    widget_icon_type: '1',
    widget_language: null,
    widget_position: '1',
    widget_position_mobile: '1',
    widget_custom_trigger: 'accessibilityWidget',
    widget_custom_trigger_enabled: false,
    site_id: null,
    host: null,
    widget_position_nudge: initEmptyNudge(),
    widget_position_nudge_mobile: initEmptyNudge(),
    widget_live_language_enabled: true,
    widget_layout: WidgetLayout.Full,
    widget_lst_button_enabled: false,
    widget_lst_button_icon_type: null,
    widget_lst_button_type: null,
    widget_ga_enabled: false,
  };
}

export const tuningsStore = createStore({name: 'tunings'}, withProps<TuningsState>(createInitialTuningsState()));
